module.exports = __webpack_public_path__ + "img/substitution-down-symbol.5dabece7.svg";